import {Component, DestroyRef, effect, inject, Injector, OnInit, Signal, ViewChild} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatListModule} from "@angular/material/list";
import {MatMenuModule} from "@angular/material/menu";
import {MatSidenav, MatSidenavModule} from "@angular/material/sidenav";
import {MatToolbarModule} from "@angular/material/toolbar";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {MatIconModule} from '@angular/material/icon';
import {MsalService} from '@azure/msal-angular';
import {GraphService} from '@flw-graph';
import {toSignal} from '@angular/core/rxjs-interop';
import {environment} from '@flw-env';

@Component({
  selector: 'app-header',
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule, RouterLink, RouterLinkActive, MatMenuModule
  ],
  templateUrl: './header.html',
  standalone: true,
  styleUrl: './header.scss'
})
export class Header implements OnInit{
  protected readonly buildTimestamp= environment.buildTimestamp || 'Error';
  private authService = inject(MsalService);

  public readonly logoPath = 'img.png';
  public readonly appName = 'FLEET WORK';
  public readonly navItems = [
    {
      path: 'dashboard',
      label: 'Dashboard'
    },
    {
      path: 'car-access',
      label: 'Car Access'
    }
  ];

  @ViewChild('drawer') drawer!: MatSidenav;

  toggleMenu() {
    this.drawer.toggle();
  }

  protected logout(): void {
    this.authService.logout();
  }

  private graph = inject(GraphService);
  private destroyRef = inject(DestroyRef);
  private injector = inject(Injector);
  protected displayName!: Signal<string>;
  protected profileImage!: Signal<string | undefined>;

  ngOnInit(): void {
    this.displayName=toSignal( this.graph.getProfile(), { injector: this.injector } )
    this.profileImage=toSignal( this.graph.getPhoto(), { injector: this.injector } )
    effect(() => {
    },{ injector: this.injector });
  }
}
